import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { bindable } from 'aurelia-typed-observable-plugin';
import * as CD from 'app/cd/models/essette-api';
import { ProviderService } from 'app/cd/services/provider-service';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class GroupInfoCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public providerId: string | null = null;
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public groupId: string | null = null;

    protected provider: CD.Provider | null = null;
    protected group: CD.ProviderGroup | null = null;

    protected id: guid = guid();

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly providerService: ProviderService,
        ...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        this.loadGroup();
    }



    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadGroup(): Promise<void> {
        if(!this.groupId) return;

        const includes: string[] = [
            'address.billing',
            'address.physical',
            'phoneNumber.primary',
            'phoneNumber.fax',
            'custom.target.definitions'
        ];

        try {
            this.state.beginLoad();

            const response = await this.providerService.loadProviderGroup(this.groupId, includes);
            this.group = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
